// src/constants/styles.js

export const GlobalStyles = {
    colors: {
        // Brand palette (dynamic via CSS vars, but with safe fallbacks)
        angeonBlue: "var(--kbs-primary, #00adff)",
        angeonBlueDark: "var(--kbs-secondary, #006CA8)",
        angeonBlueSoft: "rgba(8, 160, 250, 0.15)",
        primary: "var(--kbs-primary, #00adff)",
        secondary: "var(--kbs-secondary, #006CA8)",
        accent: "var(--kbs-accent, #FF5F1F)",
        textOnPrimary: "var(--kbs-text-on-primary, #14151a)",
        brandWhite: "#ffffff",
        brandBlue: "#00adff",
        brandOrange: "#FF5F1F",

        // Legacy aliases kept so existing components inherit the new brand.
        canary: "var(--kbs-primary, #00adff)",          // primary
        woodsmoke: "var(--kbs-background, #14151a)",    // main background
        kBolaBlue: "var(--kbs-text-on-primary, #14151a)", // primary contrast
        shark: "var(--kbs-surface, #1f1f2e)",           // surface / cards
        sulu: "var(--kbs-accent, #FF5F1F)",             // accent / links

        manatee: "var(--kbs-text-muted, #9ca3af)",      // muted text
        white: "var(--kbs-text-on-surface, #ffffff)",   // text on cards
        bgAlt: "var(--kbs-background-alt, #0b0d15)",
        lightBg: "#ffffff",
        lightBgAlt: "#E2E8F0",
        lightSurface: "#EEF3F8",
        lightMuted: "#4B5563",
        border: "var(--kbs-border, #1f2937)",
        lightBorder: "#D1DCE8",
        borderSubtleDark: "rgba(255,255,255,0.08)",
        borderSubtleLight: "rgba(20,21,26,0.1)",
        overlayModal: "rgba(0,0,0,0.6)",
        // You still have direct hex access if needed:
        pablo: "#787369",
        battleshipGray: "#8f9f74",
        fuscousGray: "#524d47",
        chaletGreen: "#57663c",
        leather: "#9e715a",
        midGray: "#585a64",
        kelp: "#414e30",

        // Status colors – keep static for now (can be themed later if needed)
        lose: "#a50c0c",
        win: "#309834",
        warning: "#FFC107",
        danger: "#FF3333",
        success: "#4CAF50",
        lightSuccess: "#eefbee",
        info: "#17a2b8",
        link: "#8f8ff4",
    },
};
